import { types } from "mobx-state-tree";
import fetcher from "../utils/fetcher";
import userStore, { Role } from "./userStore";
import { persist } from "../utils/persist";

const TenantsStore = types
  .model("TenantsStore", {
    contracts: types.frozen(),
    siteContracts: types.frozen(),
    selectedProject: types.frozen(),
    selectedContract: types.frozen(),
    selectedContacts: types.frozen(),
    selectedMessage: types.frozen(),
    selectedDoc: types.frozen(),
    error: types.frozen(),
    sites: types.frozen(),
    selectedTheme: types.frozen(),
    licenses: types.frozen(),
    siteLogo: types.frozen(),
    selectedSiteSpace: types.frozen(),
    allMessages: types.frozen(),
  })
  .actions((self) => {
    const getSaleContracts = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_sale_contracts();
      if (response?.status === 200 && response?.data) {
        const contracts = response.data;

        self.setContracts(contracts);

        return contracts;
      } else {
        console.log("error:error_failed_get_sale_contracts_req");
        self.setError("error:error_failed_get_sale_contracts_req");
      }
    };

    const getSiteSaleContracts = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_site_sale_contracts();
      if (response?.status === 200 && response?.data) {
        const contracts = response.data;
        self.setSiteContracts(contracts);

        return contracts;
      } else {
        console.log("error:error_failed_get_site_sale_contracts_req");
        self.setError("error:error_failed_get_site_sale_contracts_req");
      }
    };

    const getBedekSiteSpaces = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_bedek_site_spaces();
      if (response?.status === 200 && response?.data) {
        const spaces = response.data;

        return spaces;
      } else {
        console.log("error:error_failed_get_bedek_site_spaces_req");
        self.setError("error:error_failed_get_bedek_site_spaces_req");
      }
    };

    const getSaleContract = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_sale_contract();
      if (response?.status === 200 && response?.data) {
        const contract = response.data;
        await self.setSelectedContract({
          ...contract,
          SITEID: data?.SITEID,
          DNAME: data?.DNAME,
        });
        return contract;
      } else {
        console.log("error:error_failed_get_sale_contract_req");
        self.setError("error:error_failed_get_sale_contract_req");
      }
    };

    const getSaleContractMessages = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_sale_contract_messages();
      if (response?.status === 200 && response?.data) {
        const messages = response.data;
        self.setAllMessages(messages);

        return messages;
      } else {
        console.log("error:error_failed_get_sale_contract_req");
        self.setError("error:error_failed_get_sale_contract_req");
      }
    };
    const getSaleContractDocs = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_sale_contract_docs();
      if (response?.status === 200 && response?.data) {
        const docs = response.data;
        return docs;
      } else {
        console.log("error:error_failed_get_sale_contract_req");
        self.setError("error:error_failed_get_sale_contract_req");
      }
    };

    const getSaleContractApplies = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_sale_contract_applies();
      if (response?.status === 200 && response?.data) {
        const applies = response.data;
        return applies;
      } else {
        console.log("error:error_failed_get_sale_contract_applies_req");
        self.setError("error:error_failed_get_sale_contract_applias_req");
      }
    };

    const getProjectImage = async (data) => {
      self.setError("");
      const imgRes = await fetcher().post(data).from.tenants.get_project_img();
      if (imgRes?.status === 200 && imgRes?.data) {
        const image = imgRes?.data;
        self.setSiteLogo(image);
      } else {
        console.log("error:error_failed_get_project_img_req");
        self.setError("error:error_failed_get_project_img_req");
      }
    };

    const getDepartments = async (data) => {
      self.setError("");
      const imgsRes = await fetcher().post(data).from.tenants.get_departments();
      if (imgsRes?.status === 200 && imgsRes?.data) {
        const images = imgsRes?.data;
        return images || [];
      } else {
        console.log("error:error_failed_get_departments_req");
        self.setError("error:error_failed_get_departments_req");
      }
    };

    const getCustomerSites = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_customer_sites(data);
      if (response?.status === 200 && response?.data) {
        const sites = response.data;

        self.setCustomerSites(sites);
      } else {
        console.log("error:error_failed_get_customer_sites_req");
        self.setError("error:error_failed_get_customer_sites_req");
      }
    };

    const updateCustomerSites = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.update_customer_sites(data);
      if (response?.status === 200 && response?.data?.success) {
        await self.getCustomerSites(data);
      } else {
        console.log("error:error_failed_update_customer_sites_req");
        self.setError("error:error_failed_update_customer_sites_req");
      }
    };

    const getSaleContractNote = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_sale_contract_note(data);
      if (response?.status === 200 && response?.data) {
        return response.data;
      } else {
        console.log("error:error_failed_get_sale_contract_note_req");
        self.setError("error:error_failed_get_sale_contract_note_req");
      }
    };

    const addSaleContractNote = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.add_sale_contract_note(data);
      if (response?.status === 200 && response?.data) {
        return response.data;
      } else {
        const err =
          response.data?.FORM?.InterfaceErrors?.text ||
          "error:error_failed_add_sale_contract_note_req";
        self.setError(err);
      }
    };

    const getPortalData = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_portal_user_data(data);
      if (response?.status === 200 && response?.data) {
        self.setLicenses(response?.data?.SUBLICENSENUM);
      } else {
        console.log("error:error_failed_get_portal_data_req");
        self.setError("error:error_failed_get_cportal_data_req");
      }
    };

    const updateTenants = async (data) => {
      self.setError("");

      const response = await fetcher()
        .post(data)
        .from.tenants.update_tenants(data);

      if (response?.status === 200 && response?.data) {
        self.setLicenses(response?.data?.SUBLICENSENUM);
      } else {
        console.log("error:error_failed_update_site_tenant_req");
        self.setError("error:error_failed_update_sites_tenant_req");
      }
    };

    const getTenants = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_tenants_in_portal(data);
      if (response?.status === 200 && response?.data) {
        return response?.data;
      } else {
        console.log("error:error_failed_get_site_tenant_req");
        self.setError("error:error_failed_get_sites_tenant_req");
      }
    };

    const getNoteTopics = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_note_topics(data);
      if (response?.status === 200 && response?.data) {
        return response?.data;
      } else {
        console.log("error:error_failed_get_note_topics_req");
        self.setError("error:error_failed_get_note_topics_req");
      }
    };

    const getNoteStatuses = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.get_note_statuses(data);
      if (response?.status === 200 && response?.data) {
        return response?.data;
      } else {
        console.log("error:error_failed_get_note_statuses_req");
        self.setError("error:error_failed_get_note_statuses_req");
      }
    };

    const updateMassge = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.update_message(data);
      if (response?.status === 200 && response?.data?.success) {
      } else {
        console.log("error:error_failed_update_message_req");
        self.setError("error:error_failed_update_message_req");
      }
    };

    const updateNote = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.update_note(data);
      if (response?.status === 200 && response?.data?.success) {
      } else {
        console.log("error:error_failed_update_note_req");
        self.setError("error:error_failed_update_note_req");
      }
    };

    const updateSiteActivation = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.update_site(data);
      if (response?.status === 200 && response?.data) {
        await self.getCustomerSites(data);
        self.setSelectedProject(response?.data);
      } else {
        console.log("error:error_failed_update_site_activation_req");
        self.setError("error:error_failed_update_site_activation_req");
      }
    };

    const updateTenantActivation = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.update_tenant(data);
      if (response?.status === 200 && response?.data) {
        await getSiteSaleContracts(data);
        await getCustomerSites(data);
      } else {
        console.log("error:error_failed_update_tenant_activation_req");
        self.setError(
          "error:error_failed_update_tenant_activation_req",
          response
        );
      }
    };

    const setSelectedProject = (project) => {
      self.selectedProject = project;
      self.setSelectedTheme(project?.THEME);
    };

    const setSelectedContacts = (contacts) => {
      self.selectedContacts = contacts;
    };

    const setSiteLogo = (image) => {
      self.siteLogo = image;
    };

    function setSelectedTheme(theme) {
      self.selectedTheme = theme;
    }

    const setContracts = (contracts) => {
      self.contracts = contracts;
    };

    const setCustomerSites = (sites) => {
      self.sites = sites;
    };

    const setSiteContracts = (contracts) => {
      self.siteContracts = contracts;
    };

    const setLicenses = (num) => {
      self.licenses = num;
    };

    const setSelectedContract = async (contract) => {
      self.selectedContract = contract;

      if (!!contract) {
        const data = {
          MAINCUST: userStore.userDetails.MAINCUST,
          CUST: userStore.userDetails.CUST,
          MAINENV: userStore.userDetails.MAINENV,
          CUSTNAME: userStore.userDetails.CUSTNAME,
        };
        if (tenantsStore.sites?.length === 0) {
          await tenantsStore.getCustomerSites(data);
        }
        const project = tenantsStore.sites?.find(
          (s) => s.SITENUM === tenantsStore.selectedContract?.SITENUM && s.DNAME === tenantsStore.selectedContract.DNAME
        );
        if (!!project) {
          tenantsStore.setSelectedProject(project);
        }
      }
    };

    async function sendResetPassword(data) {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.send_reset_password();

      if (response?.status !== 200) {
        const errorText =
          response?.status === 404
            ? "error:error_failed_user_not_exists"
            : "error:error_failed_reset_password_req";
        self.setError(errorText);
        return {
          isSucceed: false,
          error: errorText,
        };
      }
      return {
        isSucceed: true,
      };
    }

    async function sendLicenseUpdateEmail(data) {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.send_license_update_email();

      if (response?.status !== 200) {
        const errorText = "error:error_failed_send_license_update_email";
        self.setError(errorText);
        return {
          isSucceed: false,
          error: errorText,
        };
      }
      return {
        isSucceed: true,
      };
    }

    async function sendFormEmail(data) {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.tenants.send_form_email();

      if (response?.status !== 200) {
        const errorText = "error:error_failed_send_license_update_email";
        self.setError(errorText);
        return {
          isSucceed: false,
          error: errorText,
        };
      }
      return {
        isSucceed: true,
      };
    }

    async function resetPassword(data) {
      self.setError("");
      const response = await fetcher().post(data).from.tenants.reset_password();

      if (response?.status !== 200) {
        const errorText =
          response.status === 505
            ? "error:error_failed_same_old_pwd"
            : response.status === 404
              ? "error:error_failed_user_not_exists"
              : "error:error_failed_reset_password_req";
        self.setError(errorText);
        return {
          isSucceed: false,
          error: errorText,
        };
      }
      return {
        isSucceed: true,
      };
    }

    async function setAdminPassword(data) {
      self.setError("");
      const response = await fetcher().post(data).from.tenants.set_admin_password();

      if (response?.status !== 200) {
        const errorText =
          response.status === 404
            ? "error:error_failed_user_not_exists"
            : "error:error_failed_reset_password_req";
        self.setError(errorText);
        return {
          isSucceed: false,
          error: errorText,
        };
      }
      // Store user details from response
      if (response?.data) {
        userStore.setUserDetails({
          ...response.data,
          USERID: response.data.ID,
          MAINCUST: response.data.CUST,
          role: Role.Admin,
        });
      }
      return {
        isSucceed: true,
      };
    }

    const setSelectedDoc = (doc) => {
      self.selectedDoc = doc;
    };

    const setSelectedMessage = (message) => {
      self.selectedMessage = message;
    };

    function setError(error, response) {
      self.error =
        response?.data?.FORM?.InterfaceErrors?.text?.replace(
          /^.*?\d+\s*-\s*/,
          ""
        ) || error;
    }

    const setSelectedSiteSpace = (sitespace) => {
      self.selectedSiteSpace = sitespace;
    };

    const setAllMessages = (messages) => {
      self.allMessages = messages;
    };

    return {
      getSaleContracts,
      setContracts,
      setSelectedContract,
      setSelectedContacts,
      setSelectedMessage,
      setSelectedDoc,
      getSiteSaleContracts,
      setSiteContracts,
      updateCustomerSites,
      updateTenants,
      getCustomerSites,
      setCustomerSites,
      updateSiteActivation,
      updateTenantActivation,
      getSaleContract,
      getSaleContractDocs,
      getSaleContractMessages,
      setSelectedProject,
      setSelectedTheme,
      getProjectImage,
      sendResetPassword,
      sendLicenseUpdateEmail,
      sendFormEmail,
      resetPassword,
      setAdminPassword,
      updateMassge,
      updateNote,
      getTenants,
      getPortalData,
      setLicenses,
      getSaleContractNote,
      addSaleContractNote,
      getDepartments,
      getNoteTopics,
      getNoteStatuses,
      getSaleContractApplies,
      getBedekSiteSpaces,
      setSelectedSiteSpace,
      setError,
      setSiteLogo,
      setAllMessages
    };
  })
  .views((self) => ({
    get isError() {
      return !!self.error;
    },
  }));

let sessionStorageTenant = JSON.parse(
  window.sessionStorage.getItem("coralis-tenants-storetenant")
);

const tenantsStore = TenantsStore.create({
  contracts: sessionStorageTenant?.contracts || [],
  siteContracts: sessionStorageTenant?.siteContracts || [],
  selectedProject: sessionStorageTenant?.selectedProject || {},
  selectedContract: sessionStorageTenant?.selectedContract || null,
  selectedMessage: sessionStorageTenant?.selectedMessage || {},
  selectedDoc: sessionStorageTenant?.selectedDoc || {},
  sites: sessionStorageTenant?.sites || [],
  error: "",
  selectedTheme: sessionStorageTenant?.selectedTheme || {},
  licenses: 0,
  siteLogo: sessionStorageTenant?.siteLogo || "",
  selectedSiteSpace: sessionStorageTenant?.selectedSiteSpace || {},
  selectedContacts: sessionStorageTenant?.selectedContacts || [],
  allMessages: sessionStorageTenant?.allMessages || [],
});

sessionStorageTenant = persist("coralis-tenants-storetenant", tenantsStore, {
  storage: window.sessionStorage,
  jsonify: true,
});

export default tenantsStore;
